import styled from '@emotion/styled/macro';
import { Box } from '@feast-it/pesto';

export const Container = styled(Box)`
  box-shadow: 0px 0px 20px rgba(52, 56, 81, 0.2);

  &:after {
    content: '';
    display: block;
    width: 0px;
    height: 0px;
    margin: auto;
    border-style: solid;
    position: absolute;
    bottom: -0.5em;
    left: 50%;
    transform: translateX(-50%);

    border-width: 0.5em 0.5em 0px;
    border-color: ${({ theme }) => theme.colors.white} transparent transparent;
    border-radius: 5px;
  }
`;
